import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isNil } from 'lodash';
import { endOfMonth, format, startOfMonth } from 'date-fns';
import { trackError } from 'utils/helpers';
import { FORMAT_QT_DATE } from 'utils/helpers/datetime';
import {
  fetchAvailabilityFailure,
  fetchAvailabilitySucceeded,
  setAvailability,
} from 'redux/actions/availability';
import { useUnavailableDatesQuery } from 'redux/api_slice/availability';

const formatDate = (date) => format(date, FORMAT_QT_DATE);

// Get the availability for the current month and display it on calendar
export const useCalendarAvailability = ({ resource, currentMonth }) => {
  const fromDate = formatDate(startOfMonth(currentMonth));
  const toDate = formatDate(endOfMonth(currentMonth));
  const dispatch = useDispatch();
  const { data, isFetching, error } = useUnavailableDatesQuery(
    {
      resourceIds: [resource],
      fromDate,
      toDate,
    },
    { skip: isNil(resource) }
  );

  useEffect(() => {
    if (!isNil(data)) {
      dispatch(setAvailability(data));
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (!isNil(error)) {
      trackError(error);
      dispatch(fetchAvailabilityFailure(error));
    } else {
      dispatch(fetchAvailabilitySucceeded());
    }
  }, [dispatch, error]);

  return { isFetching };
};
